import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { Accounting, UnitDto } from '../../../../context/GlobalContext'
import { useFormikContext } from 'formik'
import { InvoiceMutationDto } from '../../../../config/finance/invoiceConfig'
import useUnits from '../../../../hooks/useUnits'
import UnitCombobox, { UnitComboboxProps } from '../../../Combobox/UnitCombobox'
import FormikInputField from '../../../Formik/FormikInputField'
import FormikComboboxField from '../../../Formik/FormikComboboxField'
import { InputProps } from '@fluentui/react-input'

export default function FinanceUnitField(props: UnitComboboxProps & InputProps): ReactElement {
    const { values } = useFormikContext<InvoiceMutationDto>()
    const { units } = useUnits()
    const unit = useMemo<UnitDto>(() => (units || []).find(data => data.key === values.unit), [values.unit, units])

    return (
        <>
            <FormikComboboxField<InvoiceMutationDto, UnitComboboxProps>
                labelKey={'invoice.edit.form.other.unit'}
                fieldName={'unit'}
                component={UnitCombobox}
                componentProps={{ ...props, clearable: !props.readOnly }}
            />
            {[Accounting.Exact].includes(unit?.accounting) && (
                <FormikInputField<InvoiceMutationDto> labelKey={'invoice.edit.form.other.period'} fieldName="period" />
            )}
        </>
    )
}
